export default __webpack_public_path__ + "media/images/fonts/glyphicons-halflings-regular-f4769f9bdb7466be65088239c12046d1.eot";